import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import RichTextEditor from 'react-rte';
import { AiOutlineDelete } from "react-icons/ai";
import Upload from '../Ui/Upload';

const StatusModal = ({ t, showModal, status, comment, setComment, loading, handleOk, handleCancel, footerOption1, footerOption2, setMailDocuments, mailDocuments }) => {

    const toolbarConfig = {
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
    };

    const handleDisableSubmitCTA = () => {
        if (status === 'EmailDocuments') {
            return loading || (mailDocuments.length === 0)
        } else {
            return (comment.toString('html') === '<p><br></p>')
        }
    };
    
    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.jobStatus.popupTitle")} - {status}</h5>
                            <button type="button" className="close p-1 rounded" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose/>
                            </button>
                        </div>
                        <div className="modal-body">
                        {(status === 'EmailDocuments') 
                        ? <div>
                                <div className="my-2 mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.jobStatus.attachments")}*</label>
                                    <div className="d-flex align-items-center">
                                        <Upload selectedFiles={mailDocuments} multiple={true} onChange={e => setMailDocuments(e.target.files)} />
                                        {(mailDocuments.length !== 0) && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => setMailDocuments([])} />}
                                    </div>
                                </div>
                            </div>
                        :<div className="my-2">
                                <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.comment")}*</p>
                                <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={comment} onChange={value => setComment(value)} />
                        </div>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={loading} className="btn btn-light-danger font-weight-bold" onClick={()=>{handleCancel();}}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.jobStatus.close")}</button>
                            <button type="button" disabled={loading} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={()=>{handleOk()}}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.jobStatus.ok")}
                                {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default StatusModal;